// Pure helpers for the Work History page. Kept free of React so the
// grouping/filter/subtotal rules are unit-testable on their own.

const MONTH_NAMES = [
    "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
    "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER",
];

// work_date is a plain YYYY-MM-DD; split it rather than going through Date,
// which would shift the day in negative-offset timezones.
export const formatWorkDate = (value) => {
    if (!value) return "TBD";
    const [y, m, d] = value.split("-");
    return `${m}/${d}/${y}`;
};

const monthLabel = (workDate) => {
    const [y, m] = workDate.split("-");
    return `${MONTH_NAMES[Number(m) - 1]} ${y}`;
};

// Groups logs into month sections (newest first). `items` honors the status
// filter and search query; `approvedHours` always reflects every approved
// log of the month so the subtotal stays meaningful under any filter.
export const buildMonthSections = (logs, { status = "all", search = "" } = {}) => {
    const query = search.trim().toLowerCase();
    // Stable sort keeps the backend's created_at tiebreak for same-day logs.
    const sorted = [...logs].sort((a, b) =>
        a.work_date < b.work_date ? 1 : a.work_date > b.work_date ? -1 : 0
    );

    const sections = [];
    const byLabel = new Map();
    sorted.forEach((entry) => {
        const label = monthLabel(entry.work_date);
        let section = byLabel.get(label);
        if (!section) {
            section = { label, approvedHours: 0, items: [] };
            byLabel.set(label, section);
            sections.push(section);
        }
        if (entry.status === "approved") section.approvedHours += Number(entry.hours);

        const matchesStatus = status === "all" || entry.status === status;
        const matchesSearch =
            !query || (entry.description || "").toLowerCase().includes(query);
        if (matchesStatus && matchesSearch) section.items.push(entry);
    });

    return sections
        .filter((section) => section.items.length > 0)
        .map((section) => ({
            ...section,
            approvedHours: Math.round(section.approvedHours * 10) / 10,
        }));
};
